import { useEffect, useState } from "react";
import * as Survey from "survey-react";
import "survey-react/survey.css";
import "./survey.css";
import { updateSurveyThunk } from "../../../store/thunks/feedbackRequestsThunk";
import { useDispatch } from "react-redux";

function SurveyComponent({ surveyJSON, id, source = "" }) {
  const dispatch = useDispatch();
  // Function to handle survey completion
  const onSurveyComplete = async (survey, options) => {
    setSurveyResult(survey.data);

    const payload = {
      surveyData: survey.data,
      dateTime: new Date(
        new Date().getTime() - new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .slice(0, 19)
        .replace("T", " "),
    };

    // Handle survey completion
    await dispatch(updateSurveyThunk({ id, ...payload }));
  };

  // Function to handle survey value changes
  const onSurveyValueChanged = (sender, options) => {
    // Handle survey value changes
  };

  // Initialize state to hold survey results
  const [surveyResult, setSurveyResult] = useState(null);
  const [surveyQuestionsCount, setSurveyQuestionsCount] = useState(0);

  const generateSurveyJSON = () => {
    const survey = {
      pages: [],
      showQuestionNumbers: "off",
      showPrevButton: true,
      goNextPageAutomatic: false,
      showCompletedPage: true,
      completeText: "Submit",
      completedHtml: `
      <div class="survey-thankyou">
      <img src="../../../../../thankyou.svg" alt="Thank You" />
        <h2>We Appreciate Your Input!</h2>
        <p>Every response brings us closer to making things even better.</p>
      </div>
    `,
    };

    if (surveyJSON) {
      if (surveyJSON.questions && surveyJSON.questions.length > 0) {
        surveyJSON.questions.forEach((question) => {
          const page = { elements: [] };

          const surveyQuestion = {
            type: question.input_type,
            name: question.qkey,
            title: question.display_text,
            isRequired: question.meta.required,
            defaultValue: question.defaultValue,
          };

          if (question.input_type === "radiogroup") {
            surveyQuestion.choices = question.options;
          }

          page.elements.push(surveyQuestion);

          // Sub-questions
          if (question.meta.sub_questions?.length > 0) {
            question.meta.sub_questions.forEach((subQuestion) => {
              page.elements.push({
                name: subQuestion.qkey,
                type: subQuestion.input_type,
                title: subQuestion.display_text,
                isRequired: subQuestion.required,
                visibleIf: subQuestion.visible_if,
                defaultValue: subQuestion.defaultValue,
              });
            });
          }

          survey.pages.push(page);
        });
      }
    }

    return survey;
  };

  const [currentPage, setCurrentPage] = useState(1);
  const onCurrentPageChanged = (survey) => {
    const pageIndex = survey.currentPageNo + 1;
    const totalPages = survey.visiblePageCount;

    setCurrentPage(pageIndex);

    const header = document.getElementById("surveyTitle");
    if (header) {
      header.innerText = `Feedback (${pageIndex}/${totalPages})`;
    }
  };

  useEffect(() => {
    if (surveyJSON && surveyJSON.questions && surveyJSON.questions.length > 0) {
      setSurveyQuestionsCount(surveyJSON?.questions.length);
    }
  }, [surveyJSON]);

  useEffect(() => {
    if (surveyQuestionsCount > 0) {
      const header = document.getElementById("surveyTitle");
      if (header) {
        header.innerText = `Feedback (1/${surveyQuestionsCount})`;
      }
    }
  }, [surveyQuestionsCount]);

  return (
    <div className={surveyQuestionsCount}>
      <div className="svfeed_custom_header">
        <h3 id="surveyTitle">Feedback Form</h3>
      </div>
      <Survey.Survey
        json={generateSurveyJSON()}
        showCompleteButton={source !== "preview"}
        showCompletedPage={true}
        onComplete={onSurveyComplete}
        onValueChanged={onSurveyValueChanged}
        onCurrentPageChanged={onCurrentPageChanged}
      />
    </div>
  );
}

export default SurveyComponent;
